// Who am I, as far as the database is concerned.
//
// Until the identity collapse, nothing could answer this: every match minted
// its own users row, so Profile and the Atlas fell back to matching on
// nickname, which meant two guests sharing a name shared a history and
// renaming yourself lost yours. users now holds one row per player, keyed by
// the account when signed in and by the install otherwise, and this resolves
// that row without creating one: a read, never a write, so opening Profile on
// a device that has never played does not mint a phantom player.
import { supabase } from '../supabase';
import { getDeviceId } from './deviceId';

let cached: string | null | undefined;

export async function getPlayerId(force = false): Promise<string | null> {
  if (!force && cached !== undefined) return cached;

  // The database answers this itself now. device_id and auth_user_id stopped
  // being readable (they are what proves a player is who they say), so the
  // client cannot filter users by them any more; my_player_id reads the
  // account from the session token and the install from the id passed in.
  const { data: mine, error } = await supabase.rpc('my_player_id', { p_device_id: getDeviceId() });
  if (!error) return (cached = (mine as string | null) ?? null);

  // A database without the function (before its migration) still lets the
  // client read the columns, so the old lookup below still works there.
  const { data: sess } = await supabase.auth.getSession();
  const authId = sess?.session?.user?.id ?? null;

  if (authId) {
    const { data } = await supabase.from('users')
      .select('id').eq('auth_user_id', authId).maybeSingle();
    if (data?.id) return (cached = data.id);
  }

  const { data } = await supabase.from('users')
    .select('id').eq('device_id', getDeviceId()).maybeSingle();
  return (cached = data?.id ?? null);
}

/** Signing in or out changes who the player is; the answer must not persist. */
export function forgetPlayerId() { cached = undefined; }
